// Tiny logger wrapper — production builds contain ZERO console references.
// In dev we bind to console.warn/error so stack traces are clean.
// `process.env.NODE_ENV` is replaced by webpack at build time, so the
// production branch is dead-code-eliminated and the dev branch is stripped.

const noop = () => {};

export const logger =
  process.env.NODE_ENV === "production"
    ? { warn: noop, error: noop }
    : {
        // eslint-disable-next-line no-console
        warn: typeof console !== "undefined" ? console.warn.bind(console) : noop,
        // eslint-disable-next-line no-console
        error: typeof console !== "undefined" ? console.error.bind(console) : noop,
      };

export default logger;
